import { render, staticRenderFns } from "./TreesTwo.vue?vue&type=template&id=1bfb015b&scoped=true&"
var script = {}
import style0 from "./TreesTwo.vue?vue&type=style&index=0&id=1bfb015b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb015b",
  null
  
)

export default component.exports